import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, TINY_MARGIN } from '../../theme';

const useStyles = (isDark) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        background: isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
        overflow: 'hidden',
      },
      bottom: {
        position: 'relative',
        width: '100%',
        marginTop: 'auto',
        padding: `0 12px 12px`,
        boxSizing: 'border-box',
        [theme.breakpoints.up('md')]: {
          padding: `0 ${SMALL_MARGIN}px ${SMALL_MARGIN}px`,
        },
      },
      title: {
        marginBottom: TINY_MARGIN,
      },
      jobTitle: {
        marginBottom: TINY_MARGIN,
        color: colorsPalette.gray,
      },
      link: {
        display: 'flex',
        alignItems: 'center',
      },
      image: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
      },
      imageWrapper: {
        position: 'relative',
        height: 0,
        flexGrow: 1,
        marginBottom: -SMALL_MARGIN,
        '&:after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50%',
          background: `linear-gradient(0deg, ${
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary
          } 0%, ${fade(
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
            0.9,
          )} 17.24%, ${fade(
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
            0,
          )} 100%);`,
        },
      },
      icon: {
        marginRight: 6,
        width: 16,
      },
    }),
  );

export default useStyles;
